


















import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ChildComponentCollection from '@/common/ts/child-component/ChildComponentCollection';
import SubNavigationItem from '@/webcomponents/header/SubNavigationItem.vue';
import ParentComponentMixin from '@/common/ts/child-component/ParentComponentMixin';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

const MainNavigationItemProps = Vue.extend({
  props: {
    itemText: String,
    itemLink: String,
    editMode: Boolean,
    flyoutUrl: String, // Used in the HeaderFlyout component
  },
});

@Component
export default class MainNavigationItem extends mixins(MainNavigationItemProps, ParentComponentMixin) {
  subNavigationItems: ChildComponentCollection<SubNavigationItem> = new ChildComponentCollection<SubNavigationItem>();
  fadeIn = false;
  isActive = false;
  initial = true;
  activeSubNavItem: SubNavigationItem | null = null;
  notHovered = false;

  created () {
    this.initParentComponentMixin(
      this.subNavigationItems,
      ['SubNavigationItem'],
    );
  }

  mounted () {
    // logo Transition finished
    if (window.innerWidth <= 768) {
      this.fadeIn = true;
    }
    setTimeout(() => {
      this.fadeIn = true;
    }, 25);
  }

  get rootClass () {
    return {
      'brandhub-main-navigation-item--edit-mode': this.editMode,
      'brandhub-main-navigation-item--in': this.fadeIn,
      'brandhub-main-navigation-item--active': this.isActive,
    };
  }

  onItemClick () {
    if (this.itemText) {
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Main Navigation', this.itemText, this.itemLink);
    }

    this.isActive = true;
    const event = new CustomEvent('mainNavClicked', {
      bubbles: true,
      composed: true,
      detail: {
        clickedItem: this,
      },
    });
    this.$el.dispatchEvent(event);
  }
}
